import { Box, styled } from '@mui/material';

export const FieldContainer = styled(Box)(({ theme }) => ({
  paddingBottom: theme.spacing(2),
  ' .MuiFormHelperText-root': {
    marginLeft: 0,
  },
}));
